import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

const getTableOrders = (company) => {
    return axios.get(`method/restaurant_management.api.get_floor_data`, {
        params: {
            company,
        },
    });
};

export const useGetTableOrders = ({ company }) => {
    return useQuery(
        ["getTableOrdersData", company],
        async () => {
            const { data } = await getTableOrders(company);
            return data;
        },
        {
            refetchOnMount: true,
            refetchOnReconnect: true,
            refetchOnWindowFocus: false,
        }
    );
};

export const useMoveOrderItems = () => {
    return useMutation(async ({ items, orderId, destinationTable, client }) => {
        const args = {
            items: items,
            destinationTable,
            client,
        };

        const params = {
            model: `Table Order`,
            name: orderId,
            method: `divide`,
            args: JSON.stringify(args),
        };
        const data = await axios.post(
            `method/frappe_helper.api.call`,
            params
        );

        return data;
    });
};

//move_table_orders
